import { RootDirectory } from "../../../../../domain/drawing";

export interface IEditTreeRootSource<T> {
  saveEditTreeRoot(treeRootSource: RootDirectory<string, T>): Promise<void>;
}

export function instanceOfIEditTreeRootSource<T>(instance: any): instance is IEditTreeRootSource<T> {
  return (instance
    && instance.saveEditTreeRoot !== undefined);
}
